/**
 * Atelier Diamante — Homepage Interactions
 * Vanilla JS: parallax, scroll reveal, horizontal scroll indicators
 * Under 100 lines. No external dependencies.
 */

(function () {
  'use strict';

  /* ── Parallax Scroll Effect on Hero Image ────────────────────────────── */
  function initHeroParallax() {
    const heroImg = document.querySelector('.ad-hero__media img');
    if (!heroImg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const update = () => {
      const scrollY = window.scrollY;
      const parallaxAmount = scrollY * 0.3;
      heroImg.style.transform = `translateY(${parallaxAmount}px)`;
    };

    window.addEventListener('scroll', update, { passive: true });
  }

  /* ── Intersection Observer for Scroll Reveals ───────────────────────── */
  function initScrollReveals() {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -80px 0px',
        threshold: 0.1,
      }
    );

    document.querySelectorAll('.ad-reveal').forEach((el) => {
      revealObserver.observe(el);
    });
  }

  /* ── Horizontal Scroll Snap for Diamond Shapes ──────────────────────── */
  function initShapeScroll() {
    const scrollContainer = document.querySelector('.ad-shapes__scroll');
    if (!scrollContainer) return;

    // Optional: Add visual indicators for scroll position
    let lastScrollPos = 0;
    scrollContainer.addEventListener('scroll', () => {
      lastScrollPos = scrollContainer.scrollLeft;
    }, { passive: true });
  }

  /* ── Design tiles ⇄ piece-type dropdown ─────────────────────────────── */
  function initDesignTiles() {
    const sel = document.getElementById('ad-ci-type');
    const tiles = document.querySelectorAll('.ad-design__tile');
    if (!sel || !tiles.length) return;

    // Tile label (lowercased) → matching <option> value
    const map = {
      'engagement rings': 'Engagement Ring',
      'pendants': 'Pendant',
      'tennis & chains': 'Tennis Chain or Bracelet',
      'wedding bands': 'Wedding Band',
      'earrings': 'Earrings',
      'something unique': 'Other',
    };
    const key = (t) => t.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

    tiles.forEach((tile) => {
      tile.setAttribute('role', 'button');
      tile.setAttribute('tabindex', '0');
      tile.setAttribute('aria-pressed', 'false');

      const choose = () => {
        const val = map[key(tile)];
        if (!val) return;
        sel.value = val;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        if (window.innerWidth < 990) {
          const f = document.querySelector('.ad-design__form');
          if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      tile.addEventListener('click', choose);
      tile.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choose();
        }
      });
    });

    // Keep tile highlight in sync with the dropdown (either direction)
    sel.addEventListener('change', () => {
      tiles.forEach((t) => {
        const match = map[key(t)] === sel.value;
        t.classList.toggle('is-selected', match);
        t.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    });
  }

  /* ── Initialize All ──────────────────────────────────────────────────── */
  function init() {
    initHeroParallax();
    initScrollReveals();
    initShapeScroll();
    initDesignTiles();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
